import { render, staticRenderFns } from "./processHead.vue?vue&type=template&id=4106ff28&scoped=true"
import script from "./processHead.vue?vue&type=script&lang=js"
export * from "./processHead.vue?vue&type=script&lang=js"
import style0 from "./processHead.vue?vue&type=style&index=0&id=4106ff28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106ff28",
  null
  
)

export default component.exports